import React from 'react';
import styled from 'styled-components';
import Navigation from '../components/layout/Navigation';
import IntroSection from '../components/sections/IntroSection';

const Home: React.FC = () => {
  return (
    <HomeContainer>
      <Navigation />
      <IntroSection />
    </HomeContainer>
  );
};

const HomeContainer = styled.div`
  min-height: 100vh;
  background: ${({ theme }) => theme.colors.background};
`;

export default Home; 